import React from 'react';
import ReactDOM from 'react-dom/client'; // Importa createRoot desde react-dom/client
import { Buffer } from 'buffer'; // Importa Buffer para configurarlo globalmente
import App from './App';

// Configura Buffer globalmente
window.Buffer = Buffer;

// Selecciona el elemento root
const rootElement = document.getElementById('root');

if (rootElement) {
  // Renderiza la aplicación utilizando root.render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
